import {Injectable} from '@angular/core';
import 'rxjs/add/observable/of';
import {CriteresRechercheLogsDto} from "../api/dto/criteres.recherche.logs.dto";
import {TokenResponse} from "../api/dto/token-response.dto";
import {isNullOrUndefined} from "util";

@Injectable()
export class NavigationService {

  setCriteres(crit: CriteresRechercheLogsDto) {
    sessionStorage.setItem('criteres',JSON.stringify(crit));
  }

  getCriteres(): CriteresRechercheLogsDto {
    return JSON.parse(sessionStorage.getItem('criteres'));
  }

  setToken(token: TokenResponse) {
    sessionStorage.setItem('token',JSON.stringify(token));
  }

  getToken(): TokenResponse {
    const str = sessionStorage.getItem('token');
    if(isNullOrUndefined(str)){
      return null;
    }
    return JSON.parse(str);
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/navigation.service.ts